import React, { useEffect, useState } from 'react'
import { convertMilliSecToDateNew, makeSideBarActive } from '../../utils/EllowUtils';
import SideMenu from '../sideMenu'
import DashboardHeader from '../topbar'
import * as CONSTANTS from "../../utils/CONSTANTS";
import Styles from "./styles.module.scss";
import Table from '../../components/table';
import CandidateTimesheetHistory from "../../modal/candidateTimesheetHistory";
import { listCandidateTimeSheetList ,  getHistory , getpositionsName , sendTimesheetReminder, getCompany , getProviderEmailList, sendTimesheetApprovalReminder } from "./services";
import NotificationAlert from '../../components/notification';
import AddToEmail from '../../modal/addToEmail';
import { getMilliSec , getMilliSecUTC} from "../../utils/EllowUtils"
import { Label } from '@progress/kendo-react-labels';
import totalCountIcon from '../../assets/images/crown_icon_fill.svg';
import { useAppDispatch, useAppSelector } from "../../hooks/redux-hooks";
import Table1 from "../../components/selectTable";
import {
  Grid,
  GridCellProps,
  GridColumn as Column,
  GridItemChangeEvent,
  GridPageChangeEvent,
  GridPagerSettings,
  GridRowProps,
} from "@progress/kendo-react-grid";
import { storeSelectedRow } from '../../store/timeSheetSelectedRow/timeSheetSelectedSlice';
import file_download from "../../assets/images/file_download.svg"
import { CSVLink, CSVDownload } from "react-csv";
import { timesheetCsvHeader } from '../../utils/EllowUtils'
import mixpanelData from '../../utils/mixpanel';



const CandidateTimesheet = () => {

    const date = new Date();
    const month = date.getMonth();
    const year = date.getFullYear();
    const startDate = getMilliSecUTC(new Date(year, month, 1))
    const endDate = getMilliSecUTC(new Date(year, month + 1, 0))

    const BreadcrumsValues = ["Candidate Timesheets"];
    const menu = makeSideBarActive(CONSTANTS.sideMenu, 4);
    const [filterNumber, setFilterNumber] = useState<number>()
    const [filterValues, setFilterValues] = useState<any>()
    const [timesheetData, setTimesheetData] = useState<any>()
    const [timesheetCount, setTimesheetCount] = useState<any>()
    const [historyModal, setHistoryModal] = useState<boolean>(false)
    const [checkHistoryData, setCheckHistoryData] = useState<any>()
    const [sort, setSort] = useState<any>([]);
    const [positionName, setPositionName] = useState<any>()
    const [companyList, setCompanyList] = useState<any>();
    const [companyName , setCompanyName] = useState<any>([])
    const [customerId , setCustomerId] = useState<any>([])
    const [candidateFilterValue , setCandidateFilterValue] = useState<any>()
    const [candidateDetails, setCandidateDetails] = useState<any>()
    const [providerEmailList, setProviderEmailList] = useState<any>()
    const [toEmailModal, setToEmailModal] = useState<boolean>(false)
    const [notification, setNotification] = useState<boolean>(false)
    const [message, setMessage] = useState<string>('')
    const [type, setType] = useState<string>('success')
    const [icon, setIcon] = useState<boolean>(false)
    const [filterValue , setFilterValue ] = useState<any>()
    const [searchValue , setSearchValue] = useState<string>(' ')
    const [pageNumber, setPageNumber] = useState<number>(1)
    const [pageSize, setPageSize] = useState<number>(100)
    const [status , setStatus] = useState<any>([])

    interface AppState {
      items: any;
      total: number;
      skip: number;
      pageSize: number;
      pageable: GridPagerSettings;
    }

    const createState = (skip: number, take: number, items: any) => {
      let pagerSettings: GridPagerSettings = {
        buttonCount: 20,
        info: true,
        type: "numeric",
        pageSizes: [100, 150, 200],
        previousNext: true,
      };
      return {
        items: items,
        total: timesheetCount,
        skip: skip,
        pageSize: take,
        pageable: pagerSettings,
      };
    };

    const [state, setState] = useState<AppState>(createState(0, 100, timesheetData));

    const timeSheetSelectedRow = useAppSelector(state => state.timeSheetSelectedRow);
    
    const dispatch = useAppDispatch();
    
    useEffect(() => {
    
      let  filters = {
          "month": presentMonth,
          "year": presentYear.toString()
        }
      setFilterValues(filters)
      setCandidateFilterValue(filters)
      getListCandidateTimeSheet(1, 100, '', filters, '')
      getPositionName()
      getCompanyList()
       
    },[])

    let presentMonthNumber = new Date().getMonth();
    const months = ["January","February","March","April","May","June","July","August","September","October","November","December"];
    let presentMonth = months[presentMonthNumber]
    let presentYear = new Date().getFullYear()
    
    const getListCandidateTimeSheet = (pageNumber?: number, pageSize?: number, search?: string, filters?: any, sort?: any) => {

      let body = {}
      if (filters) {
        body = {
          filters : filters,
          sort: {
              sortBy: "startDate",
              sortOrder: "desc"
          }
        }
        setFilterValue(filters)
      }
      else {
        body = {
          filters:{
            // "month": presentMonth,
            // "year": presentYear.toString()
          },
          sort: {
            "sortBy" : "startDate",
            "sortOrder": "desc"
          },
        }
        // let filter = {
        //   "month": presentMonth,
        //   "year": presentYear.toString()
        // }
        // setFilterValues(filter)
      }
      listCandidateTimeSheetList(pageNumber, pageSize, search, body ).then((response) => {
        if (response && response.status === 1) {
          // setTimesheetData(response.data && response.data.filter((item: any) => item.month ===  CONSTANTS.MONTHS[presentMonthNumber] && item.year === presentYear.toString()))
          setTimesheetData(response.data && response.data)
          setTimesheetCount(response.responseCount)
         }
       })
    }

    const getHistoryDetails = (timesheetId: string) => {
      getHistory(timesheetId).then((response) => {
        if (response && response.status === 1) {
          setCheckHistoryData(response.data)
        }
      })
    }

    const getProviderDetails = (candidateId: string) => {
      getProviderEmailList(candidateId).then((response) => {
        if (response && response.status === 1) {
          setProviderEmailList(response.data && response.data.map((item: any) => item.email))
          setToEmailModal(true)
       }
     })
    }

  const sendReminder = (data: any) => {
     
    if(data.timesheetStatus === "2"){
      let body = {
        "timesheetId": data.timesheetId
      }
      sendTimesheetApprovalReminder(body).then((response: any) => {
        if (response && response.status === 1) {
          displayNotification("Reminder sent successfully")
        }
      })
    }else{
        setCandidateDetails(data)
        if (data.sourcedBy === 'PROVIDER') {
          getProviderDetails(data.candidateId)
        }
        else {   
          let body = {
            "timesheetId": data && data.timesheetId,
            "projectId": data && data.projectId,
            "loginId": data && data.candidateId,
            "userLoginId": localStorage.getItem('loginId'),
            "candidateType": `${data.sourcedBy} RESOURCE`,
            "candidateName": data.candidateName,
            "jobRole": data.position,
            "toEmail": data.candidateCompanyEmail
                }
          sendTimesheetReminder(body).then((response: any) => {
            if (response && response.status === 1) {
              mixpanelData('New TG - Send timesheet reminder to candidate', {
                'source': `Recruiter sends reminder to candidate for submitting timesheet`,
                "distinct_id": localStorage.getItem('Email'),
                "Recruiter email" : localStorage.getItem('Email'),
                "Timesheet id": data && data.timesheetId,
                "Project id": data && data.projectId,
                "login id": data && data.candidateId,
                "UserLoginId": localStorage.getItem('loginId'),
                "Candidate type": `${data.sourcedBy} RESOURCE`,
                "Candidate name": data.candidateName,
                "JobRole": data.position,
                "To email": data.candidateCompanyEmail
              })
              displayNotification("Reminder sent successfully")
           }
         })
        }
      }
    }

  const sendReminderProvider = (data: any) => {
      let body = {
       "timesheetId": candidateDetails && candidateDetails.timesheetId,
       "projectId": candidateDetails && candidateDetails.projectId,
       "loginId": candidateDetails && candidateDetails.candidateId,
       "userLoginId": localStorage.getItem('loginId'),
       "candidateType": `PROVIDER RESOURCE`,
       "candidateName": candidateDetails.candidateName,
       "jobRole": candidateDetails.position,
       "toEmail": data.toEmail
     }
     sendTimesheetReminder(body).then((response: any) => {
       if (response && response.status === 1) {
         setToEmailModal(false)
         mixpanelData('New TG - Send timesheet reminder to customer', {
          'source': `Recruiter sends reminder to customer for submitting timesheet`,
          "distinct_id": localStorage.getItem('Email'),
          "Recruiter email" : localStorage.getItem('Email'),
          "TimesheetId": candidateDetails && candidateDetails.timesheetId,
          "ProjectId": candidateDetails && candidateDetails.projectId,
          "LoginId": candidateDetails && candidateDetails.candidateId,
          "UserLoginId": localStorage.getItem('loginId'),
          "Candidate type": `PROVIDER RESOURCE`,
          "Candidate name": candidateDetails.candidateName,
          "JobRole": candidateDetails.position,
          "To email": data.toEmail
        })
         displayNotification("Reminder sent successfully")
      }
    })
   }

    const showHistory = (data: any) => {
      setHistoryModal(true)
      getHistoryDetails(data.timesheetId)
    }

    const pageChange = (event: GridPageChangeEvent) => {   

      setState(createState(event.page.skip, event.page.take, timesheetData));
      let page = event.page.skip !== 0 ? Math.floor(event.page.skip / event.page.skip) + 1 : 1;       
      setPageNumber(page)    
      setPageSize(event.page.take)
      getListCandidateTimeSheet(page, event.page.take, searchValue, filterValue, sort) 
    }

    const getPositionName = () => {
      getpositionsName().then((response) => {
        if (response && response.status === 1) {
          setPositionName(response.data.map((item:any)=> item.title ? item.title : ''));
        }
      })
    }

    const getCompanyList = () => {
      getCompany().then((response) => {
        if (response && response.status === 1) {
          setCompanyList(response.data.map((item:any) => item.companyName));
        }
      });
    };
    
    const applyFilter = (data: any) => {
      
      if(data.companyName !== undefined){
        data.companyName.map((item: any) => {
          return(
            companyName.push(item.companyName),
            customerId.push(item.companyId)
          )
        })
      }
      let filters = {
        company: data.company,
        positionName: data.positionName,
        status: data.status && data.status !== undefined && data.status.length > 0  ?  data.status.map((item: any) => item.name) : data.status ,
        invoiceRaised: data.invoiceRaised !== undefined ? data.invoiceRaised.name : data.invoiceRaised,
        dateWithin: data.dateWithin && data.dateWithin,
        month: data.month,
        year: data.year,
        candidateType: data.candidateType
      }
      setFilterValues(filters)
      let value = {
        "status" : data.status && data.status !== undefined && data.status.length > 0 ? data.status.map((item: any) => item.id) : undefined,
        "companyName":data.company !== undefined ? data.company : undefined,
        "position": data.positionName !== undefined ?  data.positionName : undefined,
        "invoiceRaised": data.invoiceRaised !== undefined ? (data.invoiceRaised.id === 0 ? true : false) : undefined,
        "month": data.month,
        "year": data.year,
        "submittedOn": data.dateWithin,
        "candidateType": data.candidateType
      } 
      setCandidateFilterValue(data)
      getListCandidateTimeSheet(pageNumber, pageSize, searchValue, value, '')
    }


    const searchChange = (e: any) => {   
      setSearchValue(e)
      getListCandidateTimeSheet(pageNumber, pageSize, e, filterValue, sort)
    }

    const closeTag = (data: any) => {
      
      if(data.status !== undefined && typeof(data.status[0]) === 'string'){
        setStatus([])
        data.status.map((item: any) => {
          if(item === 'Draft'){
            return(
              status.push({name: 'Draft', id: 1})
            )
          }
          if(item === 'Submitted'){
            return(
              status.push({name: 'Submitted', id: 2})
            )
          }
          if(item === 'Approved'){
            return(
              status.push({name: 'Approved', id: 3})
            )
          }
          if(item === 'Rejected'){
            return(
              status.push({name: 'Rejected', id: 4})
            )
          }
        })
        data.status = status
      }
      
      if(data.invoiceRaised !== undefined && typeof(data.invoiceRaised) === 'string'){
        if(data.invoiceRaised === 'Yes'){
          data.invoiceRaised = {name: 'Yes', id: 0}
        }
        if(data.invoiceRaised === 'No'){
          data.invoiceRaised = {name: 'No', id: 1}
        }
      }
      applyFilter(data)
    }

    // const getTablesValues = () => {
    //   getListCandidateTimeSheet(1, 100, '', '', '')
    // }

    const rowClick = (data:any) => {
  
  
    }

    const displayNotification = (message: string) => {
      setMessage(message)
      setNotification(true)
      setTimeout(() => {
         setNotification(false)
       }, 3000);
    }

    const onSelection =  (data: any) => {
      
      const newDData = data && data.map(function(item: any) {
        if(!item.newContractStartDate) {
          item.newContractStartDate = new Date(parseInt(item.contractStartDate)).toDateString()
          item.newContractEndDate = new Date(parseInt(item.contractEndDate)).toDateString()
          item.newSubmittedOn = new Date(parseInt(item.submittedOn)).toDateString()
        }
        return item
      })
      dispatch(storeSelectedRow(data))
    }

    const onRowClick = (data: any) => {
      // setSelectedCandidates(data)
    }

    const downloadTimesheetInCsv = () => {

    }

  return (
    <section className="dashboardWrapper">
      <SideMenu menu={menu} opentimesheet={'candidateTimesheets'}/>
      <div className="dashboardContent">
        <DashboardHeader
          title={BreadcrumsValues}
          applyCandidatesheetFilter={applyFilter}
          filterNumber={filterNumber}
          searchChange={searchChange}
          closeTag={closeTag}
          filterValues={filterValues}
          type='candidateTimesheet'
          positionName={positionName}
          companyList={companyList}
          candidateFilterValue={candidateFilterValue}
        />
        <div className={Styles.totalCounts}><img src={totalCountIcon}/>Total Counts<span>{timesheetCount}</span></div>
        <section className="contentBox">
          <div className="innerPadd24">
          {timeSheetSelectedRow.length > 0 ? `${timeSheetSelectedRow.length} Timesheet selected` : ''}
          {timeSheetSelectedRow.length > 0  && <CSVLink data={timeSheetSelectedRow} headers={timesheetCsvHeader} filename={"candidateTimesheets.csv"}>
              <img src={file_download} />
          </CSVLink>}
          <Table1 data={timesheetData} type={'timesheets'} total={timesheetCount} state={state} pageChange={pageChange}  pageSize={pageSize} onSelection={onSelection} onRowClick={onRowClick} showHistory={showHistory} sendReminder={sendReminder}/>

          </div>
        </section>
      </div>
      {historyModal && <CandidateTimesheetHistory onClose={() => setHistoryModal(false)} data={checkHistoryData}/>}
      {notification && <NotificationAlert onClose={() => setNotification(false) } closable={true} type={type} icon={icon} >{message}</NotificationAlert> }
      {toEmailModal && <AddToEmail onClose={() => setToEmailModal(false)} ClickHandler={sendReminderProvider} emailList={providerEmailList} />}
    </section>
  )
}

export default CandidateTimesheet